export default __webpack_public_path__ + "static/media/pds-logo-v2.762fb878.svg";